import React from "react";
import {Row, Col} from "reactstrap";
import {FaTrash} from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import InputCreator from "../../../components/Forms/components/InputCreator";
import DateCreator from "../../../components/Forms/components/DateCreator";
import {storeReportSelectedControllerList} from "../../../redux/Actions/reports.actions";
import {
  getSelectedControllerList,
  getCreateReportData,
} from "../../../redux/Selectors/reports.selectors";

const AddRecordForm = ({record, recordIndex, controllerIndex}) => {
  const {id: recordId, fields, created /*updated*/} = record;
  const dispatch = useDispatch();
  const controllerList = useSelector(getSelectedControllerList);
  const createReportData = useSelector(getCreateReportData);
  const {status = ""} = createReportData;

  const deleteRecord = () => {
    let list = [...controllerList];
    let currentController = list[controllerIndex];
    let records = [...currentController.records];
    records.splice(recordIndex, 1);
    currentController = {
      ...currentController,
      records,
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  const handleFieldInputChange = (e, fieldIndex) => {
    let newFields = [...fields];
    const newField = {...newFields[fieldIndex], [e.target.name]: e.target.value};
    newFields[fieldIndex] = newField;
    const newRecord = {...record, fields: newFields};

    let list = [...controllerList];
    let currentController = list[controllerIndex];
    let records = [...currentController.records];
    records[recordIndex] = newRecord;
    currentController = {
      ...currentController,
      records,
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  const getCalibrationDate = (dateValue) => {
    if (dateValue) {
      const calibrationDate = dateValue.split("-");
      return new Date(
        calibrationDate[0],
        calibrationDate[1] - 1,
        calibrationDate[2],
        0,
        0,
        0
      );
    }
    return dateValue;
  };

  const handleCalibrationDateChange = (newDate, last_calibration, fieldIndex) => {
    let date = newDate.toLocaleString("fr-CA", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    handleFieldInputChange(
      {
        target: {
          name: "last_calibration",
          value: {...last_calibration, value: date},
        },
      },
      fieldIndex
    );
  };

  return (
    <div style={{marginBottom: "1rem"}} data-cy="recordForm">
      <div
        style={{
          margin: "0.5rem 1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <div style={{color: "#303030", fontWeight: "bold"}} className="roboto-bold">
          Record #{recordIndex + 1}
        </div>
        <div style={{display: "flex", alignItems: "baseline"}}>
          {created && (
            <div style={{fontSize: "11px", color: "#949494"}}>
              Created:{" "}
              {new Date(created).toLocaleString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                second: "2-digit",
              })}
            </div>
          )}
          {/*updated && (
            <div style={{fontSize: "11px", color: "#949494", marginLeft: "10px"}}>
              Updated: {moment(new Date(updated)).fromNow()}
            </div>
          )*/}
          {!recordId ? (
            <FaTrash
              onClick={deleteRecord}
              style={{cursor: "pointer", alignSelf: "center"}}
              data-cy="deleteRecord"
            />
          ) : null}
        </div>
      </div>
      {fields.map((field = {}, fieldIndex) => {
        return (
          <div key={fieldIndex}>
            <div
              style={{margin: "0.5rem 1rem", color: "#20C1FF", fontWeight: "bold"}}
              className="roboto-bold"
            >
              {field.name} {field.unit ? `(${field.unit})` : ""}
            </div>
            <Row
              style={{
                marginBottom: "-1rem",
                marginRight: "0px",
                marginLeft: "0px",
                maxWidth: "100%",
              }}
            >
              <Col md={4} style={{paddingLeft: "0px", paddingRight: "0px"}}>
                <InputCreator
                  type="number"
                  label="Manually Observed"
                  large
                  style={{
                    border: "1px solid #d6d6d6",
                    maxHeight: "38px",
                    boxShadow: "none",
                  }}
                  name="manually_observed"
                  value={field.manually_observed}
                  onChange={(e) => handleFieldInputChange(e, fieldIndex)}
                  disabled={
                    status === "under-review" || status === "submitted" || recordId
                  }
                  data-cy="manuallyObserved"
                />
              </Col>
              <Col md={4} style={{paddingRight: "0px", paddingLeft: "0px"}}>
                <InputCreator
                  type="number"
                  label="Controller Observed"
                  large
                  style={{
                    border: "1px solid #d6d6d6",
                    maxHeight: "38px",
                    boxShadow: "none",
                  }}
                  name="controller_observed"
                  value={field.controller_observed}
                  onChange={(e) => handleFieldInputChange(e, fieldIndex)}
                  disabled={
                    status === "under-review" || status === "submitted" || recordId
                  }
                  data-cy="controllerObserved"
                />
              </Col>
              <Col md={4} style={{paddingLeft: "0px", paddingRight: "0px"}}>
                <DateCreator
                  label="Last Calibration"
                  large
                  value={getCalibrationDate(field.last_calibration.value)}
                  onChange={(e) => {
                    handleCalibrationDateChange(e, field.last_calibration, fieldIndex);
                  }}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  disabled={
                    !field.last_calibration.editable ||
                    status === "under-review" ||
                    status === "submitted" ||
                    recordId
                  }
                />
              </Col>
            </Row>
          </div>
        );
      })}
    </div>
  );
};

export default AddRecordForm;
